import { keepPreviousData, useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { appliesQueryKeys } from "./query-keys";

import { instance } from "@/lib/axios/instance";
import { GetAppliesResponse } from "@/types/response/GetAppliesResponse";

export type UseAppliesParams = {
  clients?: string[];
  integrations?: string[];
  applicationSourceTypes?: string[];
  matchIds?: string[];
  candidateIds?: string[];
  publicationIds?: string[];
  sortDirection?: string;
  sortColumn?: string;
  page?: number;
  pageSize?: number;
  search?: string;
  tenantId?: string | null;
  startDate?: string | null;
  endDate?: string | null;
};

export function useApplies(params: UseAppliesParams): UseQueryResult<GetAppliesResponse, AxiosError> {
  return useQuery({
    queryKey: appliesQueryKeys.list(params),
    queryFn: () =>
      instance
        .get<GetAppliesResponse>("/api/v2/Applies", { params })
        .then((res) => res.data),
    refetchOnReconnect: false,
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
  });
}
